module.exports = __webpack_public_path__ + "img/img38.bdf7e273.svg";